import type { Room } from "@spieleparadies/shared";

import { AudioSettingsPanel } from "./AudioSettingsPanel";
import { VoiceChatBar } from "./VoiceChatBar";
import type { VoiceChatHandle } from "../lib/useVoiceChat";

interface SettingsOverlayProps {
  open: boolean;
  onClose: () => void;
  voice: VoiceChatHandle;
  room: Room | null;
}

export function SettingsOverlay({ open, onClose, voice, room }: SettingsOverlayProps) {
  if (!open) return null;

  return (
    <div className="dialog" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="card" style={{ width: "min(480px, 100%)" }}>
        <div
          className="row"
          style={{ marginBottom: 16, alignItems: "center", flexWrap: "nowrap" }}
        >
          <h2 style={{ margin: 0, flex: 1 }}>Einstellungen</h2>
          <button
            className="btn btn-ghost"
            onClick={onClose}
            style={{ flex: "0 0 auto" }}
            aria-label="Schließen"
          >
            ✕
          </button>
        </div>

        <AudioSettingsPanel showVoice />

        <div style={{ marginTop: 20 }}>
          <h3 style={{ margin: "0 0 12px", fontSize: 18 }}>Voice-Chat</h3>
          <p style={{ color: "var(--text-muted)", margin: "0 0 12px", fontSize: 13 }}>
            Sprich mit deinen Mitspielern. Beim Start fragt dein Browser nach
            der Erlaubnis für dein Mikro. Funktioniert über HTTPS oder
            localhost.
          </p>
          <VoiceChatBar voice={voice} room={room} />
        </div>
      </div>
    </div>
  );
}
